import { Link } from 'react-router-dom';
import { categories } from '@/mocks/sports';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20arena%20with%20dramatic%20stadium%20lights%20and%20atmospheric%20fog%2C%20abstract%20artistic%20interpretation%20of%20multiple%20sports%20in%20motion%2C%20dark%20cinematic%20background%20with%20warm%20golden%20accent%20lighting%2C%20professional%20sports%20photography%20style%2C%20clean%20composition%2C%20luxurious%20and%20energetic%20mood&width=1800&height=800&seq=hero-bg-sports&orientation=landscape"
          alt="九游体育 - 专业体育赛事平台"
          className="w-full h-full object-cover object-top"
          title="九游体育 - 官方体育赛事平台"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-md border border-background-50/20 mb-6">
            <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
            <span className="text-sm font-medium text-background-50/90">
              欧冠决赛 · 皇马 vs 曼城 · 即将开赛
            </span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-tight mb-4">
            让每一场比赛
            <br />
            都<strong className="text-accent-400">精彩无限</strong>
          </h1>
          <p className="text-base md:text-lg text-background-50/75 max-w-2xl mx-auto leading-relaxed mb-8">
            九游体育是专业的体育赛事平台，覆盖足球、篮球、网球、电竞、F1赛车等热门赛事，
            提供实时赛况、深度数据分析及赛事直播服务，为您带来极致的体育娱乐体验。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/football"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-football-line mr-2"></i>
              探索热门赛事
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解九游体育
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CategorySection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            赛事分类
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            全方位覆盖热门赛事
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            从绿茵场到篮球馆，从网球场到电竞舞台，我们为您提供一站式赛事资讯
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 rounded-xl overflow-hidden cursor-pointer h-[320px] md:h-[380px] flex flex-col"
            >
              <div className="relative h-[55%] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20">
                  <i className={`${cat.icon} text-lg text-background-50`}></i>
                </div>
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 mb-2">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {cat.description}
                </p>
                <span className="mt-3 text-sm font-medium text-primary-500 flex items-center gap-1">
                  查看赛事
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform duration-200"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}